<template>
	<div class="contentbox">
		<ul class="tabs-ul-list">
            <li v-for="(item, index) in tabName" :key="index">
                <a :class="item.value === selectaVal ? 'active' : ''" @click="tabClick(item.value,item.name)">{{item.name}}</a>
            </li>
        </ul>
        <div class="tabs-ul-con" style="padding-top: 30px;">
            <!-- <router-view></router-view> -->
            <agent-recharge-gear v-if="selectaVal==1"></agent-recharge-gear>
            <agent-recharge-plan v-if="selectaVal==2"></agent-recharge-plan>
        </div>
        <agent-pop :visible.sync="isShowDialogAgent"></agent-pop>
	</div>
</template>
<script>
import AgentPop from '@/components/AgentPop'
import AgentRechargeGear from '@/components/AgentRechargeGear'
import AgentRechargePlan from '@/components/AgentRechargePlan'
export default {
    components: {
        AgentPop,
        AgentRechargeGear,
        AgentRechargePlan
	},
    data() {
        return {
            tabName: [
                {
                    value: 1,
                    name: '创建充值档位'
                },{
                    value: 2,
                    name: '充值方案配置'
                },
            ],
            selectaVal:1,
            isShowDialogAgent:true,
        }
    },
    computed: {},
    watch: {
    },
    created(){
        if(JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
            this.isShowDialogAgent = false
        } else {
            this.isShowDialogAgent = true
        }
    },
    mounted: function() {
        console.log(this.$route)
    },
    methods: {
        tabClick (value, name) {
            // this.$router.push({ path:  path})
            this.selectaVal = value
            console.log(name)
        }
    }
}
</script>
<style lang="sass">

</style>
